import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-save-fill 317",
  "use": "icon-save-fill 317-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-save-fill 317\"><path d=\"M320 170.666667v213.333333h384V191.381333l149.333333 153.322667V789.333333a64 64 0 0 1-64 64h-85.333333V533.333333H320v320h-85.333333a64 64 0 0 1-64-64V234.666667a64 64 0 0 1 64-64h85.333333z m320 448v234.666666H384V618.666667h256z m-42.666667 42.666666h-170.666666v64h170.666666v-64z m42.666667-490.666666v149.333333H384V170.666667h256z\" p-id=\"21839\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol